import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Input, InputNumber, Select, Tag } from 'antd';
import EditableContext from './EditableContext';
import EventEmitter from '../utils/eventEmitter';




const EditableCell = ({title, editable, children, options, dataIndex, record, inputType, handleSave, readOnly, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);

  

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);
  

  useEffect(() => {
    if (record) {
      const value = form.getFieldValue(`${dataIndex}${record.key}`);
      // console.log(value)
      if (value === undefined && options) {
        // let id = record
        let account = options.find(opt => opt.value === record[dataIndex]);
        
        if (account !== undefined) {
          console.log(account.label)
          form.setFieldValue(`${dataIndex}${record.key}`, account.label);
        } 
        if (record.attribute_id) {
          form.setFieldValue(`v${dataIndex}${record.key}`, account.values);
        }
      }
    }
  },[form.getFieldValue('tax_id')])

  const toggleEdit = () => {
    setEditing(!editing);
    if (dataIndex !== undefined) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      
      toggleEdit();
      handleSave({...record, ...values}, form);
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  const deSelect = (v, option, key) => {
    // console.log(v, option);
    option['id'] = key;
    EventEmitter.dispatch('remove_tax', option);
  }

  const onChange = (v, opt) => {
    form.setFieldValue(`${dataIndex}${record.key}`, opt.label );
    if (dataIndex === 'product_id' && record.description !== undefined) {
      // console.log('set description')
      form.setFieldValue(`description`, opt.label);
    }

    if (dataIndex === 'product_id' && opt.cost !== undefined) {
      form.setFieldValue(`price`, parseFloat(opt.cost));
    }

    // if (dataIndex === 'product_id' && opt.tax_id !== undefined) {
    //   form.setFieldValue('tax_id', opt.tax_id);
    // }
    // form.getFieldValue(`${dataIndex}${record.key}`)

    if (dataIndex === 'attribute_id') {
      form.setFieldValue('attr_values', opt.values);
    }
  }

  const filter = (input, option) => (
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  )
  // console.log(form.getFieldValue(`${dataIndex}${record.key}`))
  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item className='m-0' name={dataIndex}>
        {inputType === 'select' ?
        <Select showSearch filterOption={filter} ref={inputRef} options={options} onChange={onChange} style={{width: '100%'}} onBlur={save} /> :
        (inputType === 'tags' || dataIndex === 'values') ?
        <Select ref={inputRef} mode='tags' options={form.getFieldValue('attr_values') !== undefined ? form.getFieldValue('attr_values') : options} onChange={(v, opt)=>{ form.setFieldValue(`${dataIndex}${record.key}`, opt)}} style={{width: '100%'}} onBlur={save} onDeselect={(v, opt) => deSelect(v, opt, record.key)} /> :
        inputType === 'number' ?
        <InputNumber ref={inputRef} className='input-outline-none w-full' onPressEnter={save} onBlur={save}  /> :
        <Input ref={inputRef} className='input-outline-none w-full' onPressEnter={save} onBlur={save} />}
      </Form.Item>
    ) : (
      <div className="editable-cell-value-wrap" onClick={readOnly === false ? toggleEdit : ()=>{}} >
        {
          (inputType === 'select' && dataIndex === 'source_location') ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          (inputType === 'select' && dataIndex === 'destination_location') ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          (inputType === 'select' && dataIndex.includes('_id')) ? form.getFieldValue(`${dataIndex}${record.key}`) : 
          (inputType === 'select' && form.getFieldValue('tax') !== undefined) ? form.getFieldValue(`'tax`) : 
          ((inputType === 'tags' || dataIndex === 'values') && form.getFieldValue(`${dataIndex}${record.key}`)) ? form.getFieldValue(`${dataIndex}${record.key}`).map((tax, idx) => <Tag key={idx}>{tax.label ? tax.label : tax.value}</Tag>) : 
          // typeof(children) === 'object' ? children.map((tax, idx) => <Tag key={idx}>{tax}</Tag>) :
          children
        }
      </div>
    );
  }
  return <td {...restProps} className={editing ? 'py-0' : 'py-1'} onClick={(!editing && !readOnly) ? toggleEdit : (e)=>{e.preventDefault(); e.stopPropagation();}}>{childNode}</td>;
};



export default EditableCell;